import CustomDialog from "./Dialog";
export default CustomDialog;
